let _access_token = ''
let _roles = []
const MANAGER = 'manager'
const ADMIN = 'admin'
const SUPERADMIN = 'super_admin'

const storageKey = {
  access_token: 'roulette-access-token'
}

const User = {
  getToken () {
    if ('localStorage' in window)
      _access_token = window.localStorage.getItem(storageKey.access_token, _access_token)

    return _access_token
  },
  signIn (access_token, roles) {
    _access_token = access_token
    _roles = roles
    if ('localStorage' in window)
      window.localStorage.setItem(storageKey.access_token, _access_token)

  },
  signOut () {
    _access_token = ''
    _roles = []
    if ('localStorage' in window)
      window.localStorage.setItem(storageKey.access_token, '')

  },
  setRoles (roles) {
    _roles = roles
  },
  getRoles () {
    return _roles
  },
  isAdmin () {
    return _roles.includes(ADMIN)
  },
  isManager () {
    return _roles.includes(MANAGER)
  },
  isSuperAdmin () {
    return _roles.includes(SUPERADMIN)
  },
  isAuth () {
    if ('localStorage' in window)
      _access_token = window.localStorage.getItem(storageKey.access_token) || ''

    return _access_token.length !== 0
  },
  hasAdminAccess () {
    return this.isAdmin() || this.isSuperAdmin()
  },
  hasAccess () {
    return this.isAdmin() || this.isManager() || this.isSuperAdmin()
  }
}

export default User
